import { render } from "./TheExperts.vue?vue&type=template&id=5b6ac7d2"
import script from "./TheExperts.vue?vue&type=script&lang=js"
export * from "./TheExperts.vue?vue&type=script&lang=js"

import "./TheExperts.vue?vue&type=style&index=0&id=5b6ac7d2&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@5.6.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__